/* eslint-disable camelcase */
import React, { ChangeEvent } from 'react';
import Tooltip from '../common/Tooltip';

type SettingsData = {
    NOTIFICATIONS_MANAGEMENT: {
        upcoming_interview?: boolean;
    };
}

type TNotificationsManagement = {
    settingsData: SettingsData;
    onSettingChange: (newSettings: SettingsData) => void;
}

export function NotificationsManagement({
    settingsData,
    onSettingChange,
}: TNotificationsManagement) {

    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        onSettingChange({
            NOTIFICATIONS_MANAGEMENT: {
                upcoming_interview: event.target.checked,
            },
        });
    };

    return (
        <div className="system-settings-section">
            <div className="system-settings-section__header">
                <div className="system-settings-section__title">
                    Notifications Management
                </div>
            </div>
            <div className="system-settings-section__content">
                <table className="table-settings">
                    <tbody>
                        <tr>
                            <td>
                                <span>Upcoming induction session</span>
                                <span className="table-settings__tooltip">
                                    <Tooltip
                                        tooltip="Notify agents about an upcoming induction session."
                                    >
                                        <i className="icon icon-infomation-circle" />
                                    </Tooltip>
                                </span>
                            </td>
                            <td>
                                <label className="settings-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={
                                            settingsData.NOTIFICATIONS_MANAGEMENT.upcoming_interview
                                        }
                                        onChange={handleCheckboxChange}
                                    />
                                    <div className="settings-checkbox__container">
                                        <div className="settings-checkbox__indicator" />
                                        <span className="settings-checkbox__yes-label">
                                            Yes
                                        </span>
                                        <span className="settings-checkbox__no-label">
                                            No
                                        </span>
                                    </div>
                                </label>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
